import { Route, Routes } from 'react-router-dom';
import { PublicRoute } from './PublicRoutes';
import { PrivateRoute } from './PrivateRoutes';
import { DashboardRoutes } from './DashboardRoutes';
import LoginPage from '../pages/login/LoginPage';
import LoginCallback from '../pages/login/LoginCallback';



export const AppRouter = () => {
  return (
    <>

      <Routes>

        <Route path="login/*" element={
          <PublicRoute>

            <Routes>
              <Route path="/*" element={<LoginPage />} />
            </Routes>
          </PublicRoute>
        }
        />

        <Route path="/callback" element={<LoginCallback />} />


        <Route path="/*" element={
          <PrivateRoute>
            <DashboardRoutes />
          </PrivateRoute>
        } />





      </Routes>

    </>
  )
}